let _isInBrowser = false;
/**
 * 判断是否为浏览器环境
 */
function isInBrowser() {
    if (_isInBrowser === false) {
        _isInBrowser = typeof window !== 'undefined';
    }
    return _isInBrowser;
}

export { isInBrowser };
